module.exports = __webpack_public_path__ + "static/NOI3-d97cf80a3fc8809ffd42abbf25eb6ed8.png";